/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * This is the OpenAPI Document on Azure Functions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import { setSearchParams } from '../patch/common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    line1?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    line3?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    county?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    postCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    country?: string;
}
/**
 * 
 * @export
 * @interface AttendanceStatistics
 */
export interface AttendanceStatistics {
    /**
     * 
     * @type {number}
     * @memberof AttendanceStatistics
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof AttendanceStatistics
     */
    unique: number;
    /**
     * 
     * @type {number}
     * @memberof AttendanceStatistics
     */
    repeat: number;
}
/**
 * 
 * @export
 * @interface Attendee
 */
export interface Attendee {
    /**
     * 
     * @type {string}
     * @memberof Attendee
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Attendee
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Attendee
     */
    company?: string;
    /**
     * 
     * @type {string}
     * @memberof Attendee
     */
    jobTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof Attendee
     */
    fcaNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Attendee
     */
    bio?: string;
    /**
     * 
     * @type {string}
     * @memberof Attendee
     */
    photoUri?: string;
    /**
     * 
     * @type {number}
     * @memberof Attendee
     */
    totalEvents: number;
    /**
     * 
     * @type {SatisfactionScores}
     * @memberof Attendee
     */
    scores?: SatisfactionScores;
    /**
     * 
     * @type {string}
     * @memberof Attendee
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof Attendee
     */
    phone?: string;
    /**
     * 
     * @type {Address}
     * @memberof Attendee
     */
    address?: Address;
    /**
     * 
     * @type {boolean}
     * @memberof Attendee
     */
    canContact?: boolean;
}
/**
 * 
 * @export
 * @interface Banner
 */
export interface Banner {
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    linkUrl: string;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    imageUrl: string;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    imageAltText?: string;
}
/**
 * 
 * @export
 * @interface ChartItem
 */
export interface ChartItem {
    /**
     * 
     * @type {string}
     * @memberof ChartItem
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof ChartItem
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof ChartItem
     */
    value?: number;
    /**
     * 
     * @type {SatisfactionScores}
     * @memberof ChartItem
     */
    scores?: SatisfactionScores;
}
/**
 * 
 * @export
 * @interface CombinedEventStatistics
 */
export interface CombinedEventStatistics {
    /**
     * 
     * @type {EventStatistics}
     * @memberof CombinedEventStatistics
     */
    events?: EventStatistics;
    /**
     * 
     * @type {AttendanceStatistics}
     * @memberof CombinedEventStatistics
     */
    attendance?: AttendanceStatistics;
    /**
     * 
     * @type {SessionStatistics}
     * @memberof CombinedEventStatistics
     */
    sessions?: SessionStatistics;
    /**
     * 
     * @type {SatisfactionScores}
     * @memberof CombinedEventStatistics
     */
    scores?: SatisfactionScores;
}
/**
 * 
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    bytes?: number;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    size?: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    downloadUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    created?: string;
}
/**
 * 
 * @export
 * @interface EmbedParams
 */
export interface EmbedParams {
    /**
     * 
     * @type {string}
     * @memberof EmbedParams
     */
    type?: string;
    /**
     * 
     * @type {Array<EmbedReport>}
     * @memberof EmbedParams
     */
    embedReport?: Array<EmbedReport>;
    /**
     * 
     * @type {EmbedToken}
     * @memberof EmbedParams
     */
    embedToken?: EmbedToken;
}
/**
 * 
 * @export
 * @interface EmbedReport
 */
export interface EmbedReport {
    /**
     * 
     * @type {string}
     * @memberof EmbedReport
     */
    reportId?: string;
    /**
     * 
     * @type {string}
     * @memberof EmbedReport
     */
    reportName?: string;
    /**
     * 
     * @type {string}
     * @memberof EmbedReport
     */
    embedUrl?: string;
}
/**
 * 
 * @export
 * @interface EmbedToken
 */
export interface EmbedToken {
    /**
     * 
     * @type {string}
     * @memberof EmbedToken
     */
    token?: string;
    /**
     * 
     * @type {string}
     * @memberof EmbedToken
     */
    tokenId?: string;
    /**
     * 
     * @type {string}
     * @memberof EmbedToken
     */
    expiration?: string;
}
/**
 * 
 * @export
 * @interface Event
 */
export interface Event {
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    eventId: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    ticketId: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    roundId?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    round?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    end: string;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    totalRegistrations: number;
    /**
     * 
     * @type {AttendanceStatistics}
     * @memberof Event
     */
    attendance?: AttendanceStatistics;
    /**
     * 
     * @type {SatisfactionScores}
     * @memberof Event
     */
    scores?: SatisfactionScores;
    /**
     * 
     * @type {boolean}
     * @memberof Event
     */
    isRound?: boolean;
}
/**
 * 
 * @export
 * @interface EventDetails
 */
export interface EventDetails {
    /**
     * 
     * @type {Array<Session>}
     * @memberof EventDetails
     */
    sessions: Array<Session>;
    /**
     * 
     * @type {Array<Presenter>}
     * @memberof EventDetails
     */
    presenters: Array<Presenter>;
    /**
     * 
     * @type {Array<SessionPresenter>}
     * @memberof EventDetails
     */
    sessionsPresenters: Array<SessionPresenter>;
}
/**
 * 
 * @export
 * @interface EventDocument
 */
export interface EventDocument {
    /**
     * 
     * @type {string}
     * @memberof EventDocument
     */
    downloadUrl?: string;
}
/**
 * 
 * @export
 * @interface EventFeedback
 */
export interface EventFeedback {
    /**
     * 
     * @type {Array<string>}
     * @memberof EventFeedback
     */
    questions: Array<string>;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: boolean; }; }}
     * @memberof EventFeedback
     */
    responses: { [key: string]: { [key: string]: boolean; }; };
}
/**
 * 
 * @export
 * @interface EventScores
 */
export interface EventScores {
    /**
     * 
     * @type {{ [key: string]: SatisfactionScores; }}
     * @memberof EventScores
     */
    scores?: { [key: string]: SatisfactionScores; };
    /**
     * 
     * @type {string}
     * @memberof EventScores
     */
    currentPartnerAlias?: string;
}
/**
 * 
 * @export
 * @interface EventStatistics
 */
export interface EventStatistics {
    /**
     * 
     * @type {number}
     * @memberof EventStatistics
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof EventStatistics
     */
    previous: number;
    /**
     * 
     * @type {number}
     * @memberof EventStatistics
     */
    upcoming: number;
}
/**
 * 
 * @export
 * @interface EventsCharts
 */
export interface EventsCharts {
    /**
     * 
     * @type {Array<ChartItem>}
     * @memberof EventsCharts
     */
    recentAttendance: Array<ChartItem>;
    /**
     * 
     * @type {Array<ChartItem>}
     * @memberof EventsCharts
     */
    highestAttendance: Array<ChartItem>;
    /**
     * 
     * @type {Array<ChartItem>}
     * @memberof EventsCharts
     */
    recentScores: Array<ChartItem>;
    /**
     * 
     * @type {Array<ChartItem>}
     * @memberof EventsCharts
     */
    highestScores: Array<ChartItem>;
    /**
     * 
     * @type {Array<ChartItem>}
     * @memberof EventsCharts
     */
    attendanceByType: Array<ChartItem>;
}
/**
 * 
 * @export
 * @interface FileData
 */
export interface FileData {
    /**
     * 
     * @type {string}
     * @memberof FileData
     */
    url: string;
    /**
     * 
     * @type {number}
     * @memberof FileData
     */
    size: number;
}
/**
 * 
 * @export
 * @interface Filter
 */
export interface Filter {
    /**
     * 
     * @type {string}
     * @memberof Filter
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Filter
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof Filter
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof Filter
     */
    kind: FilterKindEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FilterKindEnum {
    Radio = 'Radio',
    Checkbox = 'Checkbox'
}

/**
 * 
 * @export
 * @interface FilterGroup
 */
export interface FilterGroup {
    /**
     * 
     * @type {string}
     * @memberof FilterGroup
     */
    title: string;
    /**
     * 
     * @type {Array<Filter>}
     * @memberof FilterGroup
     */
    filters: Array<Filter>;
}
/**
 * 
 * @export
 * @interface MarketingActivity
 */
export interface MarketingActivity {
    /**
     * 
     * @type {string}
     * @memberof MarketingActivity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MarketingActivity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MarketingActivity
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof MarketingActivity
     */
    publicationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketingActivity
     */
    deadlineDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketingActivity
     */
    completedDate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MarketingActivity
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarketingActivity
     */
    isCompleted?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof MarketingActivity
     */
    objectiveIds?: Array<string>;
}
/**
 * 
 * @export
 * @interface MarketingObjective
 */
export interface MarketingObjective {
    /**
     * 
     * @type {string}
     * @memberof MarketingObjective
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MarketingObjective
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MarketingObjective
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof MarketingObjective
     */
    progress?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketingObjective
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketingObjective
     */
    dueDate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MarketingObjective
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarketingObjective
     */
    isCompleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarketingObjective
     */
    isArchived?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof MarketingObjective
     */
    activityIds?: Array<string>;
}
/**
 * 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * 
     * @type {number}
     * @memberof Notification
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    url?: string;
    /**
     * 
     * @type {object}
     * @memberof Notification
     */
    data?: object;
    /**
     * 
     * @type {boolean}
     * @memberof Notification
     */
    isRead?: boolean;
}
/**
 * 
 * @export
 * @interface NotificationData
 */
export interface NotificationData {
    /**
     * 
     * @type {number}
     * @memberof NotificationData
     */
    unreadCount: number;
    /**
     * 
     * @type {Array<Notification>}
     * @memberof NotificationData
     */
    items: Array<Notification>;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationData
     */
    anyMoreItems?: boolean;
}
/**
 * 
 * @export
 * @interface Presenter
 */
export interface Presenter {
    /**
     * 
     * @type {string}
     * @memberof Presenter
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Presenter
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Presenter
     */
    company?: string;
    /**
     * 
     * @type {string}
     * @memberof Presenter
     */
    photoUri?: string;
}
/**
 * 
 * @export
 * @interface Question
 */
export interface Question {
    /**
     * 
     * @type {string}
     * @memberof Question
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Question
     */
    text: string;
}
/**
 * 
 * @export
 * @interface QuestionResponse
 */
export interface QuestionResponse {
    /**
     * 
     * @type {string}
     * @memberof QuestionResponse
     */
    questionId: string;
    /**
     * 
     * @type {number}
     * @memberof QuestionResponse
     */
    score: number;
    /**
     * 
     * @type {string}
     * @memberof QuestionResponse
     */
    details?: string;
}
/**
 * 
 * @export
 * @interface Report
 */
export interface Report {
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    reportId: string;
}
/**
 * 
 * @export
 * @interface SatisfactionScores
 */
export interface SatisfactionScores {
    /**
     * 
     * @type {number}
     * @memberof SatisfactionScores
     */
    overall?: number;
    /**
     * 
     * @type {number}
     * @memberof SatisfactionScores
     */
    content?: number;
    /**
     * 
     * @type {number}
     * @memberof SatisfactionScores
     */
    presenter?: number;
}
/**
 * 
 * @export
 * @interface Session
 */
export interface Session {
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    name: string;
}
/**
 * 
 * @export
 * @interface SessionPresenter
 */
export interface SessionPresenter {
    /**
     * 
     * @type {string}
     * @memberof SessionPresenter
     */
    sessionId: string;
    /**
     * 
     * @type {string}
     * @memberof SessionPresenter
     */
    presenterId: string;
}
/**
 * 
 * @export
 * @interface SessionStatistics
 */
export interface SessionStatistics {
    /**
     * 
     * @type {number}
     * @memberof SessionStatistics
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof SessionStatistics
     */
    previous: number;
    /**
     * 
     * @type {number}
     * @memberof SessionStatistics
     */
    upcoming: number;
    /**
     * 
     * @type {number}
     * @memberof SessionStatistics
     */
    month: number;
}
/**
 * 
 * @export
 * @interface Settings
 */
export interface Settings {
    /**
     * 
     * @type {string}
     * @memberof Settings
     */
    logoUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Settings
     */
    showMarketing?: boolean;
}
/**
 * 
 * @export
 * @interface Subscription
 */
export interface Subscription {
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface Survey
 */
export interface Survey {
    /**
     * 
     * @type {string}
     * @memberof Survey
     */
    id: string;
    /**
     * 
     * @type {Array<Question>}
     * @memberof Survey
     */
    questions: Array<Question>;
}
/**
 * 
 * @export
 * @interface SurveyResponse
 */
export interface SurveyResponse {
    /**
     * 
     * @type {string}
     * @memberof SurveyResponse
     */
    surveyId: string;
    /**
     * 
     * @type {Array<QuestionResponse>}
     * @memberof SurveyResponse
     */
    responses?: Array<QuestionResponse>;
}
/**
 * 
 * @export
 * @interface Tile
 */
export interface Tile {
    /**
     * 
     * @type {string}
     * @memberof Tile
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof Tile
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof Tile
     */
    imageUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Tile
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface TileGroup
 */
export interface TileGroup {
    /**
     * 
     * @type {string}
     * @memberof TileGroup
     */
    title?: string;
    /**
     * 
     * @type {Array<Tile>}
     * @memberof TileGroup
     */
    items: Array<Tile>;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    propertyName: string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    errorMessage: string;
}
/**
 * 
 * @export
 * @interface ViewOfTheRoom
 */
export interface ViewOfTheRoom {
    /**
     * 
     * @type {string}
     * @memberof ViewOfTheRoom
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ViewOfTheRoom
     */
    labels?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ViewOfTheRoom
     */
    axes?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ViewOfTheRoom
     */
    total?: number;
    /**
     * 
     * @type {string}
     * @memberof ViewOfTheRoom
     */
    prefix?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewOfTheRoom
     */
    suffix?: string;
    /**
     * 
     * @type {Array<ViewOfTheRoomData>}
     * @memberof ViewOfTheRoom
     */
    data: Array<ViewOfTheRoomData>;
}
/**
 * 
 * @export
 * @interface ViewOfTheRoomData
 */
export interface ViewOfTheRoomData {
    /**
     * 
     * @type {string}
     * @memberof ViewOfTheRoomData
     */
    name: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ViewOfTheRoomData
     */
    values: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ViewOfTheRoomData
     */
    formattedValues?: Array<string>;
}

/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSettings: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBanners: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/banners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'up' | 'down'} [direction] The direction
         * @param {number} [initialId] The ID of the first required notification
         * @param {number} [take] The maximum number of notifications to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (direction?: 'up' | 'down', initialId?: number, take?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (initialId !== undefined) {
                localVarQueryParameter['initialId'] = initialId;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTiles: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/tiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} lastId The ID of the last read notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationsAsRead: async (lastId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lastId' is not null or undefined
            assertParamExists('markNotificationsAsRead', 'lastId', lastId)
            const localVarPath = `/account/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)

            if (lastId !== undefined) {
                localVarQueryParameter['lastId'] = lastId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountSettings(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Settings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountSettings(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBanners(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Banner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBanners(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {'up' | 'down'} [direction] The direction
         * @param {number} [initialId] The ID of the first required notification
         * @param {number} [take] The maximum number of notifications to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(direction?: 'up' | 'down', initialId?: number, take?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(direction, initialId, take, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTiles(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TileGroup>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTiles(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} lastId The ID of the last read notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markNotificationsAsRead(lastId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markNotificationsAsRead(lastId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSettings(options?: any): AxiosPromise<Settings> {
            return localVarFp.getAccountSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBanners(options?: any): AxiosPromise<Array<Banner>> {
            return localVarFp.getBanners(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {'up' | 'down'} [direction] The direction
         * @param {number} [initialId] The ID of the first required notification
         * @param {number} [take] The maximum number of notifications to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(direction?: 'up' | 'down', initialId?: number, take?: number, options?: any): AxiosPromise<NotificationData> {
            return localVarFp.getNotifications(direction, initialId, take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTiles(options?: any): AxiosPromise<Array<TileGroup>> {
            return localVarFp.getTiles(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} lastId The ID of the last read notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationsAsRead(lastId: number, options?: any): AxiosPromise<void> {
            return localVarFp.markNotificationsAsRead(lastId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getNotifications operation in AccountApi.
 * @export
 * @interface AccountApiGetNotificationsRequest
 */
export interface AccountApiGetNotificationsRequest {
    /**
     * The direction
     * @type {'up' | 'down'}
     * @memberof AccountApiGetNotifications
     */
    readonly direction?: 'up' | 'down'

    /**
     * The ID of the first required notification
     * @type {number}
     * @memberof AccountApiGetNotifications
     */
    readonly initialId?: number

    /**
     * The maximum number of notifications to retrieve
     * @type {number}
     * @memberof AccountApiGetNotifications
     */
    readonly take?: number
}

/**
 * Request parameters for markNotificationsAsRead operation in AccountApi.
 * @export
 * @interface AccountApiMarkNotificationsAsReadRequest
 */
export interface AccountApiMarkNotificationsAsReadRequest {
    /**
     * The ID of the last read notification
     * @type {number}
     * @memberof AccountApiMarkNotificationsAsRead
     */
    readonly lastId: number
}

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public getAccountSettings(options?: any) {
        return AccountApiFp(this.configuration).getAccountSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public getBanners(options?: any) {
        return AccountApiFp(this.configuration).getBanners(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountApiGetNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public getNotifications(requestParameters: AccountApiGetNotificationsRequest = {}, options?: any) {
        return AccountApiFp(this.configuration).getNotifications(requestParameters.direction, requestParameters.initialId, requestParameters.take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public getTiles(options?: any) {
        return AccountApiFp(this.configuration).getTiles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountApiMarkNotificationsAsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public markNotificationsAsRead(requestParameters: AccountApiMarkNotificationsAsReadRequest, options?: any) {
        return AccountApiFp(this.configuration).markNotificationsAsRead(requestParameters.lastId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DataPacksApi - axios parameter creator
 * @export
 */
export const DataPacksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} subscription The subscription name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments: async (subscription: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscription' is not null or undefined
            assertParamExists('getDocuments', 'subscription', subscription)
            const localVarPath = `/data-packs/list/{subscription}`
                .replace(`{${"subscription"}}`, encodeURIComponent(String(subscription)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptions: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-packs/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataPacksApi - functional programming interface
 * @export
 */
export const DataPacksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataPacksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} subscription The subscription name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocuments(subscription: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Document>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocuments(subscription, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptions(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Subscription>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DataPacksApi - factory interface
 * @export
 */
export const DataPacksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataPacksApiFp(configuration)
    return {
        /**
         * 
         * @param {string} subscription The subscription name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments(subscription: string, options?: any): AxiosPromise<Array<Document>> {
            return localVarFp.getDocuments(subscription, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptions(options?: any): AxiosPromise<Array<Subscription>> {
            return localVarFp.getSubscriptions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getDocuments operation in DataPacksApi.
 * @export
 * @interface DataPacksApiGetDocumentsRequest
 */
export interface DataPacksApiGetDocumentsRequest {
    /**
     * The subscription name
     * @type {string}
     * @memberof DataPacksApiGetDocuments
     */
    readonly subscription: string
}

/**
 * DataPacksApi - object-oriented interface
 * @export
 * @class DataPacksApi
 * @extends {BaseAPI}
 */
export class DataPacksApi extends BaseAPI {
    /**
     * 
     * @param {DataPacksApiGetDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataPacksApi
     */
    public getDocuments(requestParameters: DataPacksApiGetDocumentsRequest, options?: any) {
        return DataPacksApiFp(this.configuration).getDocuments(requestParameters.subscription, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataPacksApi
     */
    public getSubscriptions(options?: any) {
        return DataPacksApiFp(this.configuration).getSubscriptions(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttendeeFilters: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/events/attendees/filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {string} ticketId The ticket ID
         * @param {Array<string>} facets The facets
         * @param {'ascending' | 'descending'} [direction] The sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttendeeRankings: async (eventId: string, ticketId: string, facets: Array<string>, direction?: 'ascending' | 'descending', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getAttendeeRankings', 'eventId', eventId)
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('getAttendeeRankings', 'ticketId', ticketId)
            // verify required parameter 'facets' is not null or undefined
            assertParamExists('getAttendeeRankings', 'facets', facets)
            const localVarPath = `/events/attendees/rankings/{eventId}/{ticketId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"ticketId"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (facets) {
                let mapped = facets.map(value => (<any>"Array<string>" !== "Array<string>") ? JSON.stringify(value) : (value || ""));
                localVarHeaderParameter['facets'] = mapped.join(COLLECTION_FORMATS["csv"]);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'} period The time period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttendeeStatisticsForPeriod: async (period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'period' is not null or undefined
            assertParamExists('getAttendeeStatisticsForPeriod', 'period', period)
            const localVarPath = `/events/attendees/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {string} ticketId The ticket ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttendeesForEvent: async (eventId: string, ticketId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getAttendeesForEvent', 'eventId', eventId)
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('getAttendeesForEvent', 'ticketId', ticketId)
            const localVarPath = `/events/{eventId}/{ticketId}/attendees`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"ticketId"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'} period The time period
         * @param {string} [name] A partial contact name
         * @param {string} [company] A partial company name
         * @param {string} [email] A partial email address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttendeesForPeriod: async (period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear', name?: string, company?: string, email?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'period' is not null or undefined
            assertParamExists('getAttendeesForPeriod', 'period', period)
            const localVarPath = `/events/attendees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (company !== undefined) {
                localVarQueryParameter['company'] = company;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailsForEvent: async (eventId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getDetailsForEvent', 'eventId', eventId)
            const localVarPath = `/events/{eventId}/details`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {string} ticketId The ticket ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentForEvent: async (eventId: string, ticketId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getDocumentForEvent', 'eventId', eventId)
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('getDocumentForEvent', 'ticketId', ticketId)
            const localVarPath = `/events/{eventId}/{ticketId}/document`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"ticketId"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} lowerBound The lower bound
         * @param {string} upperBound The upper bound
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsByDateRange: async (lowerBound: string, upperBound: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lowerBound' is not null or undefined
            assertParamExists('getEventsByDateRange', 'lowerBound', lowerBound)
            // verify required parameter 'upperBound' is not null or undefined
            assertParamExists('getEventsByDateRange', 'upperBound', upperBound)
            const localVarPath = `/events/diary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)

            if (lowerBound !== undefined) {
                localVarQueryParameter['lowerBound'] = (lowerBound as any instanceof Date) ?
                    (lowerBound as any).toISOString() :
                    lowerBound;
            }

            if (upperBound !== undefined) {
                localVarQueryParameter['upperBound'] = (upperBound as any instanceof Date) ?
                    (upperBound as any).toISOString() :
                    upperBound;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} eventIds The event IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsById: async (eventIds: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventIds' is not null or undefined
            assertParamExists('getEventsById', 'eventIds', eventIds)
            const localVarPath = `/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)

            if (eventIds) {
                let mapped = eventIds.map(value => (<any>"Array<string>" !== "Array<string>") ? JSON.stringify(value) : (value || ""));
                localVarHeaderParameter['eventIds'] = mapped.join(COLLECTION_FORMATS["csv"]);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'} period The time period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsChartsForPeriod: async (period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'period' is not null or undefined
            assertParamExists('getEventsChartsForPeriod', 'period', period)
            const localVarPath = `/events/charts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} attendeeId The attendee ID
         * @param {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'} period The events period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsForAttendee: async (attendeeId: string, period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'attendeeId' is not null or undefined
            assertParamExists('getEventsForAttendee', 'attendeeId', attendeeId)
            // verify required parameter 'period' is not null or undefined
            assertParamExists('getEventsForAttendee', 'period', period)
            const localVarPath = `/events/attendees/{attendeeId}/events`
                .replace(`{${"attendeeId"}}`, encodeURIComponent(String(attendeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'} period The time period
         * @param {string} [name] A partial event name
         * @param {string} [round] A partial round name
         * @param {Array<string>} [type] An array of event types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsForPeriod: async (period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear', name?: string, round?: string, type?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'period' is not null or undefined
            assertParamExists('getEventsForPeriod', 'period', period)
            const localVarPath = `/events/period`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (round !== undefined) {
                localVarQueryParameter['round'] = round;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'} period The time period
         * @param {string} [name] A partial event name
         * @param {string} [round] A partial round name
         * @param {Array<string>} [type] An array of event types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsStatisticsForPeriod: async (period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear', name?: string, round?: string, type?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'period' is not null or undefined
            assertParamExists('getEventsStatisticsForPeriod', 'period', period)
            const localVarPath = `/events/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (round !== undefined) {
                localVarQueryParameter['round'] = round;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {string} ticketId The ticket ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedbackForEvent: async (eventId: string, ticketId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getFeedbackForEvent', 'eventId', eventId)
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('getFeedbackForEvent', 'ticketId', ticketId)
            const localVarPath = `/events/{eventId}/{ticketId}/feedback`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"ticketId"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {string} ticketId The ticket ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoresForEvent: async (eventId: string, ticketId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getScoresForEvent', 'eventId', eventId)
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('getScoresForEvent', 'ticketId', ticketId)
            const localVarPath = `/events/{eventId}/{ticketId}/scores`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"ticketId"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {string} ticketId The ticket ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewsForEvent: async (eventId: string, ticketId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getViewsForEvent', 'eventId', eventId)
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('getViewsForEvent', 'ticketId', ticketId)
            const localVarPath = `/events/{eventId}/{ticketId}/views`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"ticketId"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttendeeFilters(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FilterGroup>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttendeeFilters(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {string} ticketId The ticket ID
         * @param {Array<string>} facets The facets
         * @param {'ascending' | 'descending'} [direction] The sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttendeeRankings(eventId: string, ticketId: string, facets: Array<string>, direction?: 'ascending' | 'descending', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttendeeRankings(eventId, ticketId, facets, direction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'} period The time period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttendeeStatisticsForPeriod(period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CombinedEventStatistics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttendeeStatisticsForPeriod(period, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {string} ticketId The ticket ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttendeesForEvent(eventId: string, ticketId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Attendee>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttendeesForEvent(eventId, ticketId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'} period The time period
         * @param {string} [name] A partial contact name
         * @param {string} [company] A partial company name
         * @param {string} [email] A partial email address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttendeesForPeriod(period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear', name?: string, company?: string, email?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Attendee>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttendeesForPeriod(period, name, company, email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetailsForEvent(eventId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetailsForEvent(eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {string} ticketId The ticket ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentForEvent(eventId: string, ticketId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentForEvent(eventId, ticketId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} lowerBound The lower bound
         * @param {string} upperBound The upper bound
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventsByDateRange(lowerBound: string, upperBound: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Event>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventsByDateRange(lowerBound, upperBound, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} eventIds The event IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventsById(eventIds: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Event>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventsById(eventIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'} period The time period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventsChartsForPeriod(period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventsCharts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventsChartsForPeriod(period, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} attendeeId The attendee ID
         * @param {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'} period The events period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventsForAttendee(attendeeId: string, period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Attendee>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventsForAttendee(attendeeId, period, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'} period The time period
         * @param {string} [name] A partial event name
         * @param {string} [round] A partial round name
         * @param {Array<string>} [type] An array of event types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventsForPeriod(period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear', name?: string, round?: string, type?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Event>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventsForPeriod(period, name, round, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'} period The time period
         * @param {string} [name] A partial event name
         * @param {string} [round] A partial round name
         * @param {Array<string>} [type] An array of event types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventsStatisticsForPeriod(period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear', name?: string, round?: string, type?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CombinedEventStatistics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventsStatisticsForPeriod(period, name, round, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {string} ticketId The ticket ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeedbackForEvent(eventId: string, ticketId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventFeedback>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeedbackForEvent(eventId, ticketId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {string} ticketId The ticket ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScoresForEvent(eventId: string, ticketId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventScores>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScoresForEvent(eventId, ticketId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {string} ticketId The ticket ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getViewsForEvent(eventId: string, ticketId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewOfTheRoom>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getViewsForEvent(eventId, ticketId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttendeeFilters(options?: any): AxiosPromise<Array<FilterGroup>> {
            return localVarFp.getAttendeeFilters(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {string} ticketId The ticket ID
         * @param {Array<string>} facets The facets
         * @param {'ascending' | 'descending'} [direction] The sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttendeeRankings(eventId: string, ticketId: string, facets: Array<string>, direction?: 'ascending' | 'descending', options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getAttendeeRankings(eventId, ticketId, facets, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'} period The time period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttendeeStatisticsForPeriod(period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear', options?: any): AxiosPromise<CombinedEventStatistics> {
            return localVarFp.getAttendeeStatisticsForPeriod(period, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {string} ticketId The ticket ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttendeesForEvent(eventId: string, ticketId: string, options?: any): AxiosPromise<Array<Attendee>> {
            return localVarFp.getAttendeesForEvent(eventId, ticketId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'} period The time period
         * @param {string} [name] A partial contact name
         * @param {string} [company] A partial company name
         * @param {string} [email] A partial email address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttendeesForPeriod(period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear', name?: string, company?: string, email?: string, options?: any): AxiosPromise<Array<Attendee>> {
            return localVarFp.getAttendeesForPeriod(period, name, company, email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailsForEvent(eventId: string, options?: any): AxiosPromise<EventDetails> {
            return localVarFp.getDetailsForEvent(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {string} ticketId The ticket ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentForEvent(eventId: string, ticketId: string, options?: any): AxiosPromise<EventDocument> {
            return localVarFp.getDocumentForEvent(eventId, ticketId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} lowerBound The lower bound
         * @param {string} upperBound The upper bound
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsByDateRange(lowerBound: string, upperBound: string, options?: any): AxiosPromise<Array<Event>> {
            return localVarFp.getEventsByDateRange(lowerBound, upperBound, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} eventIds The event IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsById(eventIds: Array<string>, options?: any): AxiosPromise<Array<Event>> {
            return localVarFp.getEventsById(eventIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'} period The time period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsChartsForPeriod(period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear', options?: any): AxiosPromise<EventsCharts> {
            return localVarFp.getEventsChartsForPeriod(period, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} attendeeId The attendee ID
         * @param {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'} period The events period
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsForAttendee(attendeeId: string, period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear', options?: any): AxiosPromise<Array<Attendee>> {
            return localVarFp.getEventsForAttendee(attendeeId, period, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'} period The time period
         * @param {string} [name] A partial event name
         * @param {string} [round] A partial round name
         * @param {Array<string>} [type] An array of event types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsForPeriod(period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear', name?: string, round?: string, type?: Array<string>, options?: any): AxiosPromise<Array<Event>> {
            return localVarFp.getEventsForPeriod(period, name, round, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'} period The time period
         * @param {string} [name] A partial event name
         * @param {string} [round] A partial round name
         * @param {Array<string>} [type] An array of event types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsStatisticsForPeriod(period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear', name?: string, round?: string, type?: Array<string>, options?: any): AxiosPromise<CombinedEventStatistics> {
            return localVarFp.getEventsStatisticsForPeriod(period, name, round, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {string} ticketId The ticket ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedbackForEvent(eventId: string, ticketId: string, options?: any): AxiosPromise<EventFeedback> {
            return localVarFp.getFeedbackForEvent(eventId, ticketId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {string} ticketId The ticket ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoresForEvent(eventId: string, ticketId: string, options?: any): AxiosPromise<EventScores> {
            return localVarFp.getScoresForEvent(eventId, ticketId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} eventId The event ID
         * @param {string} ticketId The ticket ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewsForEvent(eventId: string, ticketId: string, options?: any): AxiosPromise<Array<ViewOfTheRoom>> {
            return localVarFp.getViewsForEvent(eventId, ticketId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAttendeeRankings operation in EventsApi.
 * @export
 * @interface EventsApiGetAttendeeRankingsRequest
 */
export interface EventsApiGetAttendeeRankingsRequest {
    /**
     * The event ID
     * @type {string}
     * @memberof EventsApiGetAttendeeRankings
     */
    readonly eventId: string

    /**
     * The ticket ID
     * @type {string}
     * @memberof EventsApiGetAttendeeRankings
     */
    readonly ticketId: string

    /**
     * The facets
     * @type {Array<string>}
     * @memberof EventsApiGetAttendeeRankings
     */
    readonly facets: Array<string>

    /**
     * The sort direction
     * @type {'ascending' | 'descending'}
     * @memberof EventsApiGetAttendeeRankings
     */
    readonly direction?: 'ascending' | 'descending'
}

/**
 * Request parameters for getAttendeeStatisticsForPeriod operation in EventsApi.
 * @export
 * @interface EventsApiGetAttendeeStatisticsForPeriodRequest
 */
export interface EventsApiGetAttendeeStatisticsForPeriodRequest {
    /**
     * The time period
     * @type {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'}
     * @memberof EventsApiGetAttendeeStatisticsForPeriod
     */
    readonly period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'
}

/**
 * Request parameters for getAttendeesForEvent operation in EventsApi.
 * @export
 * @interface EventsApiGetAttendeesForEventRequest
 */
export interface EventsApiGetAttendeesForEventRequest {
    /**
     * The event ID
     * @type {string}
     * @memberof EventsApiGetAttendeesForEvent
     */
    readonly eventId: string

    /**
     * The ticket ID
     * @type {string}
     * @memberof EventsApiGetAttendeesForEvent
     */
    readonly ticketId: string
}

/**
 * Request parameters for getAttendeesForPeriod operation in EventsApi.
 * @export
 * @interface EventsApiGetAttendeesForPeriodRequest
 */
export interface EventsApiGetAttendeesForPeriodRequest {
    /**
     * The time period
     * @type {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'}
     * @memberof EventsApiGetAttendeesForPeriod
     */
    readonly period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'

    /**
     * A partial contact name
     * @type {string}
     * @memberof EventsApiGetAttendeesForPeriod
     */
    readonly name?: string

    /**
     * A partial company name
     * @type {string}
     * @memberof EventsApiGetAttendeesForPeriod
     */
    readonly company?: string

    /**
     * A partial email address
     * @type {string}
     * @memberof EventsApiGetAttendeesForPeriod
     */
    readonly email?: string
}

/**
 * Request parameters for getDetailsForEvent operation in EventsApi.
 * @export
 * @interface EventsApiGetDetailsForEventRequest
 */
export interface EventsApiGetDetailsForEventRequest {
    /**
     * The event ID
     * @type {string}
     * @memberof EventsApiGetDetailsForEvent
     */
    readonly eventId: string
}

/**
 * Request parameters for getDocumentForEvent operation in EventsApi.
 * @export
 * @interface EventsApiGetDocumentForEventRequest
 */
export interface EventsApiGetDocumentForEventRequest {
    /**
     * The event ID
     * @type {string}
     * @memberof EventsApiGetDocumentForEvent
     */
    readonly eventId: string

    /**
     * The ticket ID
     * @type {string}
     * @memberof EventsApiGetDocumentForEvent
     */
    readonly ticketId: string
}

/**
 * Request parameters for getEventsByDateRange operation in EventsApi.
 * @export
 * @interface EventsApiGetEventsByDateRangeRequest
 */
export interface EventsApiGetEventsByDateRangeRequest {
    /**
     * The lower bound
     * @type {string}
     * @memberof EventsApiGetEventsByDateRange
     */
    readonly lowerBound: string

    /**
     * The upper bound
     * @type {string}
     * @memberof EventsApiGetEventsByDateRange
     */
    readonly upperBound: string
}

/**
 * Request parameters for getEventsById operation in EventsApi.
 * @export
 * @interface EventsApiGetEventsByIdRequest
 */
export interface EventsApiGetEventsByIdRequest {
    /**
     * The event IDs
     * @type {Array<string>}
     * @memberof EventsApiGetEventsById
     */
    readonly eventIds: Array<string>
}

/**
 * Request parameters for getEventsChartsForPeriod operation in EventsApi.
 * @export
 * @interface EventsApiGetEventsChartsForPeriodRequest
 */
export interface EventsApiGetEventsChartsForPeriodRequest {
    /**
     * The time period
     * @type {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'}
     * @memberof EventsApiGetEventsChartsForPeriod
     */
    readonly period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'
}

/**
 * Request parameters for getEventsForAttendee operation in EventsApi.
 * @export
 * @interface EventsApiGetEventsForAttendeeRequest
 */
export interface EventsApiGetEventsForAttendeeRequest {
    /**
     * The attendee ID
     * @type {string}
     * @memberof EventsApiGetEventsForAttendee
     */
    readonly attendeeId: string

    /**
     * The events period
     * @type {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'}
     * @memberof EventsApiGetEventsForAttendee
     */
    readonly period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'
}

/**
 * Request parameters for getEventsForPeriod operation in EventsApi.
 * @export
 * @interface EventsApiGetEventsForPeriodRequest
 */
export interface EventsApiGetEventsForPeriodRequest {
    /**
     * The time period
     * @type {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'}
     * @memberof EventsApiGetEventsForPeriod
     */
    readonly period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'

    /**
     * A partial event name
     * @type {string}
     * @memberof EventsApiGetEventsForPeriod
     */
    readonly name?: string

    /**
     * A partial round name
     * @type {string}
     * @memberof EventsApiGetEventsForPeriod
     */
    readonly round?: string

    /**
     * An array of event types
     * @type {Array<string>}
     * @memberof EventsApiGetEventsForPeriod
     */
    readonly type?: Array<string>
}

/**
 * Request parameters for getEventsStatisticsForPeriod operation in EventsApi.
 * @export
 * @interface EventsApiGetEventsStatisticsForPeriodRequest
 */
export interface EventsApiGetEventsStatisticsForPeriodRequest {
    /**
     * The time period
     * @type {'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'}
     * @memberof EventsApiGetEventsStatisticsForPeriod
     */
    readonly period: 'yearToDate' | 'prevMonth' | 'prevQuarter' | 'thisQuarter' | 'rollingYear'

    /**
     * A partial event name
     * @type {string}
     * @memberof EventsApiGetEventsStatisticsForPeriod
     */
    readonly name?: string

    /**
     * A partial round name
     * @type {string}
     * @memberof EventsApiGetEventsStatisticsForPeriod
     */
    readonly round?: string

    /**
     * An array of event types
     * @type {Array<string>}
     * @memberof EventsApiGetEventsStatisticsForPeriod
     */
    readonly type?: Array<string>
}

/**
 * Request parameters for getFeedbackForEvent operation in EventsApi.
 * @export
 * @interface EventsApiGetFeedbackForEventRequest
 */
export interface EventsApiGetFeedbackForEventRequest {
    /**
     * The event ID
     * @type {string}
     * @memberof EventsApiGetFeedbackForEvent
     */
    readonly eventId: string

    /**
     * The ticket ID
     * @type {string}
     * @memberof EventsApiGetFeedbackForEvent
     */
    readonly ticketId: string
}

/**
 * Request parameters for getScoresForEvent operation in EventsApi.
 * @export
 * @interface EventsApiGetScoresForEventRequest
 */
export interface EventsApiGetScoresForEventRequest {
    /**
     * The event ID
     * @type {string}
     * @memberof EventsApiGetScoresForEvent
     */
    readonly eventId: string

    /**
     * The ticket ID
     * @type {string}
     * @memberof EventsApiGetScoresForEvent
     */
    readonly ticketId: string
}

/**
 * Request parameters for getViewsForEvent operation in EventsApi.
 * @export
 * @interface EventsApiGetViewsForEventRequest
 */
export interface EventsApiGetViewsForEventRequest {
    /**
     * The event ID
     * @type {string}
     * @memberof EventsApiGetViewsForEvent
     */
    readonly eventId: string

    /**
     * The ticket ID
     * @type {string}
     * @memberof EventsApiGetViewsForEvent
     */
    readonly ticketId: string
}

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getAttendeeFilters(options?: any) {
        return EventsApiFp(this.configuration).getAttendeeFilters(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EventsApiGetAttendeeRankingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getAttendeeRankings(requestParameters: EventsApiGetAttendeeRankingsRequest, options?: any) {
        return EventsApiFp(this.configuration).getAttendeeRankings(requestParameters.eventId, requestParameters.ticketId, requestParameters.facets, requestParameters.direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EventsApiGetAttendeeStatisticsForPeriodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getAttendeeStatisticsForPeriod(requestParameters: EventsApiGetAttendeeStatisticsForPeriodRequest, options?: any) {
        return EventsApiFp(this.configuration).getAttendeeStatisticsForPeriod(requestParameters.period, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EventsApiGetAttendeesForEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getAttendeesForEvent(requestParameters: EventsApiGetAttendeesForEventRequest, options?: any) {
        return EventsApiFp(this.configuration).getAttendeesForEvent(requestParameters.eventId, requestParameters.ticketId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EventsApiGetAttendeesForPeriodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getAttendeesForPeriod(requestParameters: EventsApiGetAttendeesForPeriodRequest, options?: any) {
        return EventsApiFp(this.configuration).getAttendeesForPeriod(requestParameters.period, requestParameters.name, requestParameters.company, requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EventsApiGetDetailsForEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getDetailsForEvent(requestParameters: EventsApiGetDetailsForEventRequest, options?: any) {
        return EventsApiFp(this.configuration).getDetailsForEvent(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EventsApiGetDocumentForEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getDocumentForEvent(requestParameters: EventsApiGetDocumentForEventRequest, options?: any) {
        return EventsApiFp(this.configuration).getDocumentForEvent(requestParameters.eventId, requestParameters.ticketId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EventsApiGetEventsByDateRangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventsByDateRange(requestParameters: EventsApiGetEventsByDateRangeRequest, options?: any) {
        return EventsApiFp(this.configuration).getEventsByDateRange(requestParameters.lowerBound, requestParameters.upperBound, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EventsApiGetEventsByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventsById(requestParameters: EventsApiGetEventsByIdRequest, options?: any) {
        return EventsApiFp(this.configuration).getEventsById(requestParameters.eventIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EventsApiGetEventsChartsForPeriodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventsChartsForPeriod(requestParameters: EventsApiGetEventsChartsForPeriodRequest, options?: any) {
        return EventsApiFp(this.configuration).getEventsChartsForPeriod(requestParameters.period, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EventsApiGetEventsForAttendeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventsForAttendee(requestParameters: EventsApiGetEventsForAttendeeRequest, options?: any) {
        return EventsApiFp(this.configuration).getEventsForAttendee(requestParameters.attendeeId, requestParameters.period, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EventsApiGetEventsForPeriodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventsForPeriod(requestParameters: EventsApiGetEventsForPeriodRequest, options?: any) {
        return EventsApiFp(this.configuration).getEventsForPeriod(requestParameters.period, requestParameters.name, requestParameters.round, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EventsApiGetEventsStatisticsForPeriodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventsStatisticsForPeriod(requestParameters: EventsApiGetEventsStatisticsForPeriodRequest, options?: any) {
        return EventsApiFp(this.configuration).getEventsStatisticsForPeriod(requestParameters.period, requestParameters.name, requestParameters.round, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EventsApiGetFeedbackForEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getFeedbackForEvent(requestParameters: EventsApiGetFeedbackForEventRequest, options?: any) {
        return EventsApiFp(this.configuration).getFeedbackForEvent(requestParameters.eventId, requestParameters.ticketId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EventsApiGetScoresForEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getScoresForEvent(requestParameters: EventsApiGetScoresForEventRequest, options?: any) {
        return EventsApiFp(this.configuration).getScoresForEvent(requestParameters.eventId, requestParameters.ticketId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EventsApiGetViewsForEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getViewsForEvent(requestParameters: EventsApiGetViewsForEventRequest, options?: any) {
        return EventsApiFp(this.configuration).getViewsForEvent(requestParameters.eventId, requestParameters.ticketId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MarketingApi - axios parameter creator
 * @export
 */
export const MarketingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} lowerBound The inclusive lower bound
         * @param {string} upperBound The exclusive upper bound
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingActivitiesByDateRange: async (lowerBound: string, upperBound: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lowerBound' is not null or undefined
            assertParamExists('getMarketingActivitiesByDateRange', 'lowerBound', lowerBound)
            // verify required parameter 'upperBound' is not null or undefined
            assertParamExists('getMarketingActivitiesByDateRange', 'upperBound', upperBound)
            const localVarPath = `/marketing/activities/range`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)

            if (lowerBound !== undefined) {
                localVarQueryParameter['lowerBound'] = (lowerBound as any instanceof Date) ?
                    (lowerBound as any).toISOString() :
                    lowerBound;
            }

            if (upperBound !== undefined) {
                localVarQueryParameter['upperBound'] = (upperBound as any instanceof Date) ?
                    (upperBound as any).toISOString() :
                    upperBound;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} activityIds The activity IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingActivitiesById: async (activityIds: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityIds' is not null or undefined
            assertParamExists('getMarketingActivitiesById', 'activityIds', activityIds)
            const localVarPath = `/marketing/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)

            if (activityIds) {
                let mapped = activityIds.map(value => (<any>"Array<string>" !== "Array<string>") ? JSON.stringify(value) : (value || ""));
                localVarHeaderParameter['activityIds'] = mapped.join(COLLECTION_FORMATS["csv"]);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} lowerBound The inclusive lower bound
         * @param {string} upperBound The exclusive upper bound
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingObjectivesByDateRange: async (lowerBound: string, upperBound: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lowerBound' is not null or undefined
            assertParamExists('getMarketingObjectivesByDateRange', 'lowerBound', lowerBound)
            // verify required parameter 'upperBound' is not null or undefined
            assertParamExists('getMarketingObjectivesByDateRange', 'upperBound', upperBound)
            const localVarPath = `/marketing/objectives/range`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)

            if (lowerBound !== undefined) {
                localVarQueryParameter['lowerBound'] = (lowerBound as any instanceof Date) ?
                    (lowerBound as any).toISOString() :
                    lowerBound;
            }

            if (upperBound !== undefined) {
                localVarQueryParameter['upperBound'] = (upperBound as any instanceof Date) ?
                    (upperBound as any).toISOString() :
                    upperBound;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} objectiveIds The objective IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingObjectivesById: async (objectiveIds: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectiveIds' is not null or undefined
            assertParamExists('getMarketingObjectivesById', 'objectiveIds', objectiveIds)
            const localVarPath = `/marketing/objectives`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)

            if (objectiveIds) {
                let mapped = objectiveIds.map(value => (<any>"Array<string>" !== "Array<string>") ? JSON.stringify(value) : (value || ""));
                localVarHeaderParameter['objectiveIds'] = mapped.join(COLLECTION_FORMATS["csv"]);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} year The year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingScheduleFile: async (year: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getMarketingScheduleFile', 'year', year)
            const localVarPath = `/marketing/schedule/{year}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MarketingApi - functional programming interface
 * @export
 */
export const MarketingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MarketingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} lowerBound The inclusive lower bound
         * @param {string} upperBound The exclusive upper bound
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarketingActivitiesByDateRange(lowerBound: string, upperBound: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MarketingActivity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketingActivitiesByDateRange(lowerBound, upperBound, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} activityIds The activity IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarketingActivitiesById(activityIds: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MarketingActivity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketingActivitiesById(activityIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} lowerBound The inclusive lower bound
         * @param {string} upperBound The exclusive upper bound
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarketingObjectivesByDateRange(lowerBound: string, upperBound: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MarketingObjective>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketingObjectivesByDateRange(lowerBound, upperBound, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} objectiveIds The objective IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarketingObjectivesById(objectiveIds: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MarketingObjective>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketingObjectivesById(objectiveIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} year The year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarketingScheduleFile(year: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketingScheduleFile(year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MarketingApi - factory interface
 * @export
 */
export const MarketingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MarketingApiFp(configuration)
    return {
        /**
         * 
         * @param {string} lowerBound The inclusive lower bound
         * @param {string} upperBound The exclusive upper bound
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingActivitiesByDateRange(lowerBound: string, upperBound: string, options?: any): AxiosPromise<Array<MarketingActivity>> {
            return localVarFp.getMarketingActivitiesByDateRange(lowerBound, upperBound, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} activityIds The activity IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingActivitiesById(activityIds: Array<string>, options?: any): AxiosPromise<Array<MarketingActivity>> {
            return localVarFp.getMarketingActivitiesById(activityIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} lowerBound The inclusive lower bound
         * @param {string} upperBound The exclusive upper bound
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingObjectivesByDateRange(lowerBound: string, upperBound: string, options?: any): AxiosPromise<Array<MarketingObjective>> {
            return localVarFp.getMarketingObjectivesByDateRange(lowerBound, upperBound, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} objectiveIds The objective IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingObjectivesById(objectiveIds: Array<string>, options?: any): AxiosPromise<Array<MarketingObjective>> {
            return localVarFp.getMarketingObjectivesById(objectiveIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} year The year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingScheduleFile(year: number, options?: any): AxiosPromise<FileData> {
            return localVarFp.getMarketingScheduleFile(year, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getMarketingActivitiesByDateRange operation in MarketingApi.
 * @export
 * @interface MarketingApiGetMarketingActivitiesByDateRangeRequest
 */
export interface MarketingApiGetMarketingActivitiesByDateRangeRequest {
    /**
     * The inclusive lower bound
     * @type {string}
     * @memberof MarketingApiGetMarketingActivitiesByDateRange
     */
    readonly lowerBound: string

    /**
     * The exclusive upper bound
     * @type {string}
     * @memberof MarketingApiGetMarketingActivitiesByDateRange
     */
    readonly upperBound: string
}

/**
 * Request parameters for getMarketingActivitiesById operation in MarketingApi.
 * @export
 * @interface MarketingApiGetMarketingActivitiesByIdRequest
 */
export interface MarketingApiGetMarketingActivitiesByIdRequest {
    /**
     * The activity IDs
     * @type {Array<string>}
     * @memberof MarketingApiGetMarketingActivitiesById
     */
    readonly activityIds: Array<string>
}

/**
 * Request parameters for getMarketingObjectivesByDateRange operation in MarketingApi.
 * @export
 * @interface MarketingApiGetMarketingObjectivesByDateRangeRequest
 */
export interface MarketingApiGetMarketingObjectivesByDateRangeRequest {
    /**
     * The inclusive lower bound
     * @type {string}
     * @memberof MarketingApiGetMarketingObjectivesByDateRange
     */
    readonly lowerBound: string

    /**
     * The exclusive upper bound
     * @type {string}
     * @memberof MarketingApiGetMarketingObjectivesByDateRange
     */
    readonly upperBound: string
}

/**
 * Request parameters for getMarketingObjectivesById operation in MarketingApi.
 * @export
 * @interface MarketingApiGetMarketingObjectivesByIdRequest
 */
export interface MarketingApiGetMarketingObjectivesByIdRequest {
    /**
     * The objective IDs
     * @type {Array<string>}
     * @memberof MarketingApiGetMarketingObjectivesById
     */
    readonly objectiveIds: Array<string>
}

/**
 * Request parameters for getMarketingScheduleFile operation in MarketingApi.
 * @export
 * @interface MarketingApiGetMarketingScheduleFileRequest
 */
export interface MarketingApiGetMarketingScheduleFileRequest {
    /**
     * The year
     * @type {number}
     * @memberof MarketingApiGetMarketingScheduleFile
     */
    readonly year: number
}

/**
 * MarketingApi - object-oriented interface
 * @export
 * @class MarketingApi
 * @extends {BaseAPI}
 */
export class MarketingApi extends BaseAPI {
    /**
     * 
     * @param {MarketingApiGetMarketingActivitiesByDateRangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingApi
     */
    public getMarketingActivitiesByDateRange(requestParameters: MarketingApiGetMarketingActivitiesByDateRangeRequest, options?: any) {
        return MarketingApiFp(this.configuration).getMarketingActivitiesByDateRange(requestParameters.lowerBound, requestParameters.upperBound, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MarketingApiGetMarketingActivitiesByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingApi
     */
    public getMarketingActivitiesById(requestParameters: MarketingApiGetMarketingActivitiesByIdRequest, options?: any) {
        return MarketingApiFp(this.configuration).getMarketingActivitiesById(requestParameters.activityIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MarketingApiGetMarketingObjectivesByDateRangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingApi
     */
    public getMarketingObjectivesByDateRange(requestParameters: MarketingApiGetMarketingObjectivesByDateRangeRequest, options?: any) {
        return MarketingApiFp(this.configuration).getMarketingObjectivesByDateRange(requestParameters.lowerBound, requestParameters.upperBound, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MarketingApiGetMarketingObjectivesByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingApi
     */
    public getMarketingObjectivesById(requestParameters: MarketingApiGetMarketingObjectivesByIdRequest, options?: any) {
        return MarketingApiFp(this.configuration).getMarketingObjectivesById(requestParameters.objectiveIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MarketingApiGetMarketingScheduleFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingApi
     */
    public getMarketingScheduleFile(requestParameters: MarketingApiGetMarketingScheduleFileRequest, options?: any) {
        return MarketingApiFp(this.configuration).getMarketingScheduleFile(requestParameters.year, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReportsApi - axios parameter creator
 * @export
 */
export const ReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} reportId The report ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportEmbedParams: async (reportId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getReportEmbedParams', 'reportId', reportId)
            const localVarPath = `/reports/embed/{reportId}`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReports: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportsApi - functional programming interface
 * @export
 */
export const ReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} reportId The report ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportEmbedParams(reportId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedParams>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportEmbedParams(reportId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReports(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Report>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReports(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportsApi - factory interface
 * @export
 */
export const ReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} reportId The report ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportEmbedParams(reportId: string, options?: any): AxiosPromise<EmbedParams> {
            return localVarFp.getReportEmbedParams(reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReports(options?: any): AxiosPromise<Array<Report>> {
            return localVarFp.getReports(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getReportEmbedParams operation in ReportsApi.
 * @export
 * @interface ReportsApiGetReportEmbedParamsRequest
 */
export interface ReportsApiGetReportEmbedParamsRequest {
    /**
     * The report ID
     * @type {string}
     * @memberof ReportsApiGetReportEmbedParams
     */
    readonly reportId: string
}

/**
 * ReportsApi - object-oriented interface
 * @export
 * @class ReportsApi
 * @extends {BaseAPI}
 */
export class ReportsApi extends BaseAPI {
    /**
     * 
     * @param {ReportsApiGetReportEmbedParamsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public getReportEmbedParams(requestParameters: ReportsApiGetReportEmbedParamsRequest, options?: any) {
        return ReportsApiFp(this.configuration).getReportEmbedParams(requestParameters.reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public getReports(options?: any) {
        return ReportsApiFp(this.configuration).getReports(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SurveysApi - axios parameter creator
 * @export
 */
export const SurveysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SurveyResponse} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurveyResponse: async (body: SurveyResponse, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createSurveyResponse', 'body', body)
            const localVarPath = `/surveys/response`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentSurvey: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/surveys/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Authorization", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveysApi - functional programming interface
 * @export
 */
export const SurveysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurveysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {SurveyResponse} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSurveyResponse(body: SurveyResponse, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSurveyResponse(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentSurvey(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Survey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentSurvey(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SurveysApi - factory interface
 * @export
 */
export const SurveysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurveysApiFp(configuration)
    return {
        /**
         * 
         * @param {SurveyResponse} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurveyResponse(body: SurveyResponse, options?: any): AxiosPromise<void> {
            return localVarFp.createSurveyResponse(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentSurvey(options?: any): AxiosPromise<Survey> {
            return localVarFp.getCurrentSurvey(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createSurveyResponse operation in SurveysApi.
 * @export
 * @interface SurveysApiCreateSurveyResponseRequest
 */
export interface SurveysApiCreateSurveyResponseRequest {
    /**
     * 
     * @type {SurveyResponse}
     * @memberof SurveysApiCreateSurveyResponse
     */
    readonly body: SurveyResponse
}

/**
 * SurveysApi - object-oriented interface
 * @export
 * @class SurveysApi
 * @extends {BaseAPI}
 */
export class SurveysApi extends BaseAPI {
    /**
     * 
     * @param {SurveysApiCreateSurveyResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public createSurveyResponse(requestParameters: SurveysApiCreateSurveyResponseRequest, options?: any) {
        return SurveysApiFp(this.configuration).createSurveyResponse(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public getCurrentSurvey(options?: any) {
        return SurveysApiFp(this.configuration).getCurrentSurvey(options).then((request) => request(this.axios, this.basePath));
    }
}


